import { render, staticRenderFns } from "./MonitoringDetailPanel.vue?vue&type=template&id=683618a6&scoped=true&"
import script from "./MonitoringDetailPanel.vue?vue&type=script&lang=js&"
export * from "./MonitoringDetailPanel.vue?vue&type=script&lang=js&"
import style0 from "./MonitoringDetailPanel.vue?vue&type=style&index=0&id=683618a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683618a6",
  null
  
)

export default component.exports